import * as React from 'react'
import { useState } from 'react';
import Button from '@mui/material/Button';
// import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
// import DialogActions from '@mui/material/DialogActions';
// import IconButton from '@mui/material/IconButton';
// import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Slide from '@mui/material/Slide';
import {ReactComponent as ExpandIcon} from '../static/icons/Expand.svg'
import { Box } from '@mui/material';
import MapListToggle from './MapListToggle';
import ListComponent from './ListComponent';
import MapComponent from './MapComponent';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

export default function RoadmapOverlay({name, questions}) {
    const [open, setOpen] = useState(false);
    const [view, setView] = useState('map')

    // TODO: Fetch Required Data for Roadmap Overlay here
  
    const handleClickOpen = () => {
      setOpen(true);
    };
    const handleClose = () => {
      setOpen(false);
    };
  
    return (
        <React.Fragment>
            <Button onClick={handleClickOpen} data-cy='expandicon-button'>
                <ExpandIcon />
            </Button>
            <Dialog
                data-cy='roadmapoverlay-dialog'
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
                maxWidth='xl'
                PaperProps={{
                    style: {
                        width: '1500px',
                        height: '1000px',
                        background: 'linear-gradient(144.47deg, #1D151D 42.84%, #4E2D33 179.39%)',
                        color: 'white',
                        borderRadius: "30px",
                        padding: "20px",
                        display: 'flex',
                        alignItems: 'center',
                    },
                }}
            >
                <Box sx={{display:'flex', }}>
                    <DialogTitle sx={{fontSize: '30px', fontWeight: 'bold'}}>{name}</DialogTitle>
                    <MapListToggle view={view} setView={setView}/>
                </Box>
                <DialogContent id="alert-dialog-slide-description" sx={{display: 'flex', justifyContent: 'center', width: '100%', height: '100%'}}>
                    {view === 'map' ? <MapComponent questions={questions}/>: <ListComponent questions={questions}/>}
                </DialogContent>
                <Box sx={{ position: 'absolute', bottom: 20, right: 20 }}>
                <Button
                    variant="contained"
                    onClick={handleClose}
                    sx={{
                    backgroundColor: 'white',
                    color: 'black',
                    '&:hover': {
                        backgroundColor: '#f0f0f0',
                    },
                    }}
                >
                    Close
                </Button>
                </Box>
            </Dialog>
        </React.Fragment>
    );
}